export class CompSearchPayloadOverrides {
  locationId: number;
  locationTypeId: number;
  minIndustrialCodeRange?: number;
  maxIndustrialCodeRange?: number;
  industrialCodeTypeId?: number;
  majorClassificationIds?: Array<number>;
  runOnDate?: Date;
}
